import { render, staticRenderFns } from "./FileEditor.vue?vue&type=template&id=b7e38f48&scoped=true&"
import script from "./FileEditor.vue?vue&type=script&lang=ts&"
export * from "./FileEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FileEditor.vue?vue&type=style&index=0&id=b7e38f48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e38f48",
  null
  
)

export default component.exports